export enum DietTag {
  VEGETARIAN = 'Вегетарианство',
  VEGAN = 'Веганство',
  SPORT = 'Спортивное питание',
  HEALTHY_HEART = 'Здоровое сердце',
  HEALTHY_STOMACH = 'Здоровый ЖКТ',
  DIABETIC = 'Диабетическое питание',
  LESS_PROTEIN = 'Низкобелковое',
  LESS_500 = 'Менее 500 ккал'
}